export default __webpack_public_path__ + "static/asesorias-fc792174c5699e61a1d31750dceba84a.png";